module.exports = __webpack_public_path__ + "img/全部.621ac86c.png";